angular
  .module('cfn')
  .service('sysCultureServiceTable.service', sysCultureServiceTableService);
sysCultureServiceTableService.$inject = ['$rootScope', '$log', '$http','translateFilter'];

function sysCultureServiceTableService($rootScope, $log, $http, translateFilter) {
  const SUPPLY_SERVICE_SEEDS_HARVEST_URL = '/365FarmNet/mod/supply-service/rest/v1.0/seeds/harvest/{cultureId}/units_unique';
  
  let showInfoMessageWhenHarvestUnitsNotUnique = (cultureId) => {
    if(cultureId) {
      let requestUrl = SUPPLY_SERVICE_SEEDS_HARVEST_URL.replace('{cultureId}',cultureId);
      $http.get(requestUrl).then(
        (response) => {
           if(response.data && response.data.unitCounter && response.data.unitCounter != 1) {
             let message = translateFilter('fe.booking.operation.harvest.culture.harvestunit.notunqiue');
             $rootScope.alertController.addTemporaryAlertWithCustomTimer(message, 'info', null, 12000);
           } 
         },
         (errorResponse) => {
            $log.error('Error getting not culture unit details from backend: ', errorResponse);
      });
    }
  }
  
  let sysCultureServiceTableService = {
          showInfoMessageWhenHarvestUnitsNotUnique: showInfoMessageWhenHarvestUnitsNotUnique
  };
  return {
    showInfoMessageWhenHarvestUnitsNotUnique:showInfoMessageWhenHarvestUnitsNotUnique
  }
  
};

export default sysCultureServiceTableService;


